import React from "react";
import ReactDOM from "react-dom";
import $ from "jquery";

let clicked_span = false;

/**
 * @param {*} width 셀렉트박스 가로 넓이 (예: "378px"), null 이면 기본값 적용
 * @param {*} height 셀렉트박스 세로 높이 (예: "50px"), null 이면 기본값 적용
 * @param {*} padding 셀렉트박스 패딩 (예: "14px 16px"), null 이면 기본값 적용
 * @param {*} pageWrapperName 셀렉트박스들이 모여있는 영역의 id 값(여러개의 selectBox 사용시 하나의 selectBox만 열려있도록 유지함), null이면 기본값 적용
 * @param {*} id 컴포넌트를 식별할 수 있는  id명, null 가능
 * @param {*} list List<map> 형태의 원본 리스트 그대로 사용
 * @param {*} disableOptions 리스트 중 비활성화 될 옵션, optionValuetName(or list)와 매칭되는 값이 리스트로 존재
 * @param {*} optionTexttName list에서 option의 text로 사용 할 키
 * @param {*} optionValuetName list에서 option의 Value로 사용 할 키
 * @param {*} onlyValue list 요소가 object 형태가 아닌 경우, null이면 false  ex) [0,1,2,3,4]
 * @param {*} onClickOption 옵션 클릭 이벤트 (예: onClickOption (text, value)), null 이면 아무 동작 하지 않음
 * @param {*} selectedText 선택 된 옵션의 text
 * @param {*} selectedValue 선택 된 옵션의 value
 * @param {*} placeHolder 아무것도 선택 하지 않았을 때 보여 줄 문구
 * @param {*} tabIndex 탭 포커싱 속성 부여(0일때 포커싱 가능)
 * @param {*} disabled 셀렉트박스 비활성화 여부, null이면 기본값 false
 * @param {*} disabledColor 비활성화시 셀렉트박스 컬러, null이면 기본값
 * @param {*} outlineColor tap 활성화시 색상, null이면 기본값
 * @param {*} selectAreaMaxHeight 셀렉트 열리는 영역 최대 높이값, null이면 기본값 적용
 * @param {*} boundingSelector 옵션 영역이 벗어나지 않아야 할 상위 DOM 요소의 클래스나 ID (예: "#popup-wrap", ".scroll-area")
 * @param {*} error 에러(빨간 테두리) 활성화 여부, null이면 false
 * @param {*} searchable 옵션 목록 내부 검색 사용 여부, 기본값 false
 * @param {*} searchPlaceHolder 검색 입력창 placeholder
 * @param {*} searchKeyNames object 옵션 검색 시 추가로 검색할 key 배열 (미지정 시 text/value 검색)
 */
class SelectBoxV2 extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			is_option_open: false,
			search_keyword: "",
		}
	}

	componentDidMount() {

		let this_component = this;

		$(document).ready(function(){
			$('html').click(function(e) {
				if(!$(e.target).hasClass("select_area") && !$(e.target).hasClass("select_search_input")) { // 바깥영역 클릭
					this_component.closeOption(e); // 옵션 닫힘
				}
				// 아래 코드만 사용해도 작동 됨
				// this_component.closeOption(e); // 옵션 닫힘
			});

			// 다른 셀렉트 박스는 닫기
			$('#'+this_component.props.pageWrapperName).on("click",'.select_area',function(e) {
				if (this_component.props.id != null) {
					if (!$(e.target).hasClass("select_option") && !$(e.target).hasClass("select_search_input") && $(e.target).attr('id') !== this_component.props.id) { // select_option/검색창을 클릭하지 않았으며, 현재 클릭한 id와 넘겨 받은 id가 다른 경우
						this_component.closeOption(e); // 옵션 닫힘
					}
				} 
			});

			// 선택된 글자(span) 클릭할 경우 (옵션이 열려있을때만 클릭 된다)
			$('#'+this_component.props.pageWrapperName).on("click",'.select_txt',function(e) {
				if (this_component.state.is_option_open) {
					this_component.closeOption(e, true); // 옵션 닫힘
				}
			});
		});

		this.bindPortalScrollCloseEvent();
	}

	componentDidUpdate() {

	}

	componentWillUnmount() {
		this.unbindPortalScrollCloseEvent();
	}

	openToggleOption(e) {
		e.preventDefault();
		e.stopPropagation(); // 상위 클릭 이벤트 막기
		let {is_option_open} = this.state;
		if (this.state.is_option_open) {
			is_option_open = false;
		} else {
			if(!clicked_span){
				is_option_open = true;
			}
		}
		this.setState({
			is_option_open: is_option_open,
		}, () => {
			clicked_span = false;
			if(is_option_open){
				// 버튼 스크롤 중앙
				if(this.props.onlyValue){
					for(var i=0;i<this.props.list.length;i++){
						if(this.props.selectedValue != null && this.props.list[i] == this.props.selectedValue){
							let option_position = $("#select_option_area").height()/2 - 19;
							$("#select_option_area").scrollTop($("#select_option_"+i).position().top - option_position);
						}
					}
				} else{
					for(var i=0;i<this.props.list.length;i++){
						if(this.props.selectedValue != null && this.props.list[i][this.props.optionValuetName] == this.props.selectedValue){
							let option_position = $("#select_option_area").height()/2 - 19;
							$("#select_option_area").scrollTop($("#select_option_"+i).position().top - option_position);
						}
					}
				}

				setTimeout(() => {
					const $area = $("#select_option_area");
					const $trigger = $("#" + this.escapeJQuerySelector(this.props.id));

					if ($area.length > 0 && $trigger.length > 0) {
						const areaHeight = $area.outerHeight();
						const triggerRect = $trigger[0].getBoundingClientRect(); // 👈 화면 기준 위치
						const triggerTop = triggerRect.top;
						const triggerBottom = triggerRect.bottom;

						// boundingSelector 있는 경우, 그것도 화면 기준으로 계산
						let boundaryTop = 0;
						let boundaryBottom = window.innerHeight; // 기본은 화면 하단

						if (this.props.boundingSelector) {
							const $bound = $(this.props.boundingSelector);
							if ($bound.length > 0) {
							const boundRect = $bound[0].getBoundingClientRect(); // 👈 화면 기준 위치
							boundaryTop = boundRect.top;
							boundaryBottom = boundRect.bottom;
							}
						}

						const spaceBelow = boundaryBottom - triggerBottom - 10;
						const spaceAbove = triggerTop - boundaryTop - 10;

						const defaultMaxHeight = 304;
						const propMaxHeight = this.toPxNumber(this.props.selectAreaMaxHeight) ?? defaultMaxHeight;
						const shouldOpenTop =
							spaceBelow < 120 &&             // 아래 공간이 작고
							areaHeight > spaceBelow &&     // 실제 옵션 높이도 못 들어가고
							spaceAbove > 120;              // 위에는 들어갈 수 있을 만큼 여유 있는 경우

						const direction = shouldOpenTop ? 'top' : 'bottom';

						if (direction === 'top') {
							$area.css({
							top: "auto",
							bottom: $trigger.outerHeight() + 8,
							transform: "none",
							maxHeight: Math.min(propMaxHeight, spaceAbove) + "px"
							});
						} else {
							$area.css({
							top: $trigger.outerHeight(),
							bottom: "auto",
							transform: "translate(-50%, 4px)",
							maxHeight: Math.min(propMaxHeight, spaceBelow) + "px"
							});
						}
					}
				}, 0);
			}
		});
	}

	escapeJQuerySelector(selector) {
		return selector.replace(/([!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~])/g, "\\$1");
	}

	toPxNumber(val) {
		if (typeof val === "string") {
			val = val.trim();
			if (val.endsWith("px")) {
				return parseFloat(val);
			}
			// calc 등은 지원하지 않음
			return null;
		}
		if (typeof val === "number") return val;
		return null;
	}

	closeOption(e, span) {
		if(span){
			clicked_span = true;
		}
		this.setState({
			is_option_open: false,
			search_keyword: "",
		});
	}

	renderOptionArea = () => {
		const {
			selectAreaMaxHeight,
			list,
			onlyValue,
			disableOptions,
			selectedValue,
			onClickOption,
			optionValuetName,
			optionTexttName,
			usePortal,
			searchable,
			searchPlaceHolder,
			searchKeyNames,
		} = this.props;

		const searchKeyword = String(this.state.search_keyword || "").trim().toLowerCase();
		const sourceList = Array.isArray(list) ? list : [];
		const optionItems = sourceList
			.map((obj, originalIdx) => ({ obj, originalIdx }))
			.filter(({ obj }) => {
				if (!searchable || !searchKeyword) return true;

				if (onlyValue) {
					return String(obj ?? "").toLowerCase().includes(searchKeyword);
				}

				const keys = Array.isArray(searchKeyNames) && searchKeyNames.length > 0
					? searchKeyNames
					: [optionTexttName, optionValuetName];
				const searchableText = keys
					.filter(Boolean)
					.map((key) => obj && obj[key] !== undefined && obj[key] !== null ? String(obj[key]) : "")
					.join(" ")
					.toLowerCase();

				return searchableText.includes(searchKeyword);
			});

		const optionArea = (
			<div
				id={usePortal ? `${this.props.id}_select_option_area` : "select_option_area"}
				className={usePortal ? "select_option_area select_option_area_portal" : "select_option_area"}
				style={
					usePortal
						? this.getPortalOptionAreaStyle()
						: selectAreaMaxHeight
							? { top: this.props.height, maxHeight: selectAreaMaxHeight }
							: { top: this.props.height }
				}
			>
				{searchable ? (
					<div
						className="select_search_wrap"
						style={{
							position: "sticky",
							top: 0,
							zIndex: 2,
							width: "100%",
							padding: "2px 8px",
							background: "#fff",
							border: "0px solid",
    						borderBottom: "0px solid",
						}}
						onMouseDown={(e) => e.stopPropagation()}
						onClick={(e) => e.stopPropagation()}
					>
						<input
							type="text"
							className="select_search_input"
							value={this.state.search_keyword}
							placeholder={searchPlaceHolder}
							autoFocus
							onMouseDown={(e) => e.stopPropagation()}
							onClick={(e) => e.stopPropagation()}
							onChange={(e) => this.setState({ search_keyword: e.target.value })}
							onKeyDown={(e) => {
								e.stopPropagation();
								if (e.keyCode === 27 || e.key === "Escape") {
									this.closeOption(e);
								}
							}}
							style={{
								width: "100%",
								height: "34px",
								padding: "6px 10px",
								border: "1px solid #d8dde3",
								borderRadius: "5px",
								outline: "none",
								fontSize: "13px",
							}}
						/>
					</div>
				) : null}

				{
					optionItems.length > 0
						? optionItems.map(({ obj, originalIdx }) => (
							onlyValue
								? disableOptions != null && disableOptions.length > 0 && disableOptions.indexOf(obj) >= 0
									? <button key={originalIdx} className="select_none_option" type="button" id={"select_option_" + originalIdx} index={originalIdx}>{obj}</button>
									: selectedValue != null && selectedValue == obj
										? <button key={originalIdx} className="select_option" type="button" id={"select_option_" + originalIdx} index={originalIdx} style={{ backgroundColor: "#f7f7f7" }} onClick={onClickOption ? e => onClickOption(obj, obj, this.props.id) : ""}>{obj}</button>
										: <button key={originalIdx} className="select_option" type="button" id={"select_option_" + originalIdx} index={originalIdx} onClick={onClickOption ? e => onClickOption(obj, obj, this.props.id) : ""}>{obj}</button>
								: disableOptions != null && disableOptions.length > 0 && disableOptions.indexOf(obj[optionValuetName]) >= 0
									? (
										<button
											key={originalIdx}
											className="select_none_option"
											type="button"
											id={"select_option_" + originalIdx}
											index={originalIdx}
										>
											{this.renderOptionContent(obj)}
										</button>
									)
									: selectedValue != null && selectedValue == obj[optionValuetName]
										? (
											<button
												key={originalIdx}
												className="select_option"
												type="button"
												id={"select_option_" + originalIdx}
												index={originalIdx}
												style={{ backgroundColor: "#f7f7f7" }}
												onClick={onClickOption ? e => onClickOption(obj[optionTexttName], obj[optionValuetName], this.props.id) : ""}
											>
												{this.renderOptionContent(obj)}
											</button>
										)
										: (
											<button
												key={originalIdx}
												className="select_option"
												type="button"
												id={"select_option_" + originalIdx}
												index={originalIdx}
												onClick={onClickOption ? e => onClickOption(obj[optionTexttName], obj[optionValuetName], this.props.id) : ""}
											>
												{this.renderOptionContent(obj)}
											</button>
										)
						))
						: <button className="select_none_option" type="button">{searchable && searchKeyword ? "검색 결과가 없습니다." : "선택할 옵션이 없습니다."}</button>
				}
			</div>
		);

		if (usePortal && typeof document !== "undefined") {
			return ReactDOM.createPortal(optionArea, document.body);
		}

		return optionArea;
	};

	getPortalOptionAreaStyle = () => {
		const trigger = document.getElementById(this.props.id);

		if (!trigger) {
			return {};
		}

		const rect = trigger.getBoundingClientRect();
		const maxHeight = this.props.selectAreaMaxHeight || "220px";

		return {
			position: "fixed",
			top: rect.bottom + 4 + "px",
			left: rect.left + "px",
			width: rect.width + "px",
			maxHeight: maxHeight,
			zIndex: 99999,
		};
	};

	bindPortalScrollCloseEvent = () => {
		const { usePortal, portalScrollCloseSelector, id } = this.props;

		if (!usePortal || !portalScrollCloseSelector || !id) {
			return;
		}

		this.portalScrollEventName = `scroll.selectboxPortal_${id}`;

		$(portalScrollCloseSelector).off(this.portalScrollEventName);
		$(portalScrollCloseSelector).on(this.portalScrollEventName, () => {
			if (this.state.is_option_open) {
			this.setState({
				is_option_open: false,
			});
			}
		});
	};
	unbindPortalScrollCloseEvent = () => {
		const { portalScrollCloseSelector } = this.props;

		if (portalScrollCloseSelector && this.portalScrollEventName) {
			$(portalScrollCloseSelector).off(this.portalScrollEventName);
		}
	};

	renderOptionContent = (obj) => {
		const { optionTexttName, optionImageName } = this.props;

		if (optionImageName && obj && obj[optionImageName]) {
			return (
			<span
				style={{
				display: "flex",
				alignItems: "center",
				gap: "8px",
				width: "100%",
				}}
			>
				<img
				src={obj[optionImageName]}
				alt={obj[optionTexttName] || ""}
				style={{
					width: "100%",
					height: "100%",
					// maxWidth: "62px",
					maxHeight: "20px",
					objectFit: "contain",
					flexShrink: 0,
				}}
				/>
			</span>
			);
		}

		return obj ? obj[optionTexttName] : "";
		};

	render () {
		const {width, height, padding, id, className, disabled, disabledColor,
			outlineColor, error, tabIndex, placeHolder,
			selectAreaMaxHeight, list, onlyValue, disableOptions,
			selectedValue, onClickOption, optionValuetName,
			optionTexttName, optionImageName} = this.props;
		
		const selectedText = this.props.selectedText ? this.props.selectedText : onlyValue ? selectedValue : getSelectBoxSelectIdx(list,optionTexttName,optionValuetName,selectedValue);
		return (
			<>
				<style>
					{`
						/* portal 사용 시 옵션 영역 스타일 */
						.select_option_area_portal {
							overflow: auto !important;
							display: flex !important;
							flex-direction: column !important;
							justify-content: flex-start !important;
							align-items: center !important;
							border: 1px solid !important;
							border-color: rgb(139, 139, 139) !important;
							border-radius: 6px !important;
							background-color: #fff !important;
						}

						.select_option_area_portal button {
							width: 100% !important;
							padding: 8px 16px !important;
							text-align: left !important;
							word-break: break-all;
							-webkit-user-select: none;
							-ms-user-select: none;
							user-select: none;
						}

						.select_option_area_portal .select_option:hover
						{
							background-color: #dffafa !important;
						}

						.select_search_input:focus {
							border-color: #8B8B8B !important;
						}

						.style_guide_v2 .select + .select_area div.select_search_wrap {
							width: 100% !important;
							border: 0 !important;
							border-width: 0 !important;
							border-style: none !important;
							border-color: transparent !important;
							position: relative !important;
							min-height: 40px !important;
						}
					`}
				</style>
				<div class="style_guide_v2">
					<input class="select" type="checkbox" name="select"/>
					<div id={id} class={className + " select_area" + (disabled || error ? "" : " select_able") + (error ? " select_error":"")} name="select_area" tabIndex={tabIndex != null && !disabled ? tabIndex : ""}
						onClick={disabled ? () =>  {} : e => this.openToggleOption(e)}
						onKeyDown={disabled ? () =>  {} :
							e => {
								if (e.keyCode == 32) { // 스페이스바
									this.openToggleOption(e); // 옵션 토글 (열림 or 닫힘)
								} else if (e.keyCode == 27) { // ESC
									this.closeOption(e); // 옵션 닫힘.
								}
							}}
						style={{
							width: width,
							height: height,
							padding: padding,
							display: "flex",
							cursor: disabled ? "default" : "pointer",
							backgroundColor: disabled ? disabledColor ? disabledColor :"#f7f7f7" :"",
							outlineColor: outlineColor ? outlineColor : "aqua",
							borderColor: error ? "#FF085E" : this.state.is_option_open ? "#8B8B8B" : "",
							alignItems: "center",
						}}>
						{
							optionImageName && selectedValue
							? (
								<img
								src={getSelectBoxSelectIdx(list, optionImageName, optionValuetName, selectedValue)}
								alt={selectedText || selectedValue}
								style={{
									width: "100%",
									height: "100%",
									// maxWidth: "62px",
									maxHeight: "20px",
									objectFit: "contain"
								}}
								/>
							) :
								selectedText
								?	disabled
									? <span name="selected_text_area" class="select_txt" style={{color:"#b7bdC3", alignSelf:"center"}}>{selectedText}</span>
									:	selectedValue == null
											? <span name="selected_text_area" class="select_txt" style={{color:"#878b90", alignSelf:"center"}}>{selectedText}</span>
											: <span name="selected_text_area" class="select_txt" style={{color:"#3A3A3A", alignSelf:"center"}}>{selectedText}</span>
								: <span name="selected_text_area" class="select_txt" style={{alignSelf:"center"}}>{placeHolder}</span>
						}
						{
							this.state.is_option_open
								? this.renderOptionArea()
								: ""
						}
					</div>
				</div>
			</>
		);
	}
}

SelectBoxV2.defaultProps = {
	width: "378px",
	height: "50px",
	padding: "14px 36px 14px 16px",
	pageWrapperName : "common-page-wrapper",
	optionTexttName : "",
	optionValuetName : "",
	optionImageName : "",
	placeHolder : "",
	usePortal : false,
	searchable : false,
	searchPlaceHolder : "검색어를 입력하세요.",
	searchKeyNames : null,
}

export default SelectBoxV2;

/** 셀렉트박스 선택된 값 idx
 * @param {*} list 셀렉트 박스에서 사용하는 리스트
 * @param {*} text_name 선택된 값에 대한 텍스트 필드명
 * @param {*} value_name 셀렉트 박스 선택된 값 필드명
 * @param {*} value 셀렉트 박스 선택된 값
*/
export function getSelectBoxSelectIdx(list, text_name, value_name, value){
	if(list != null && list != "" && list.length > 0){
		for(var i=0;i<list.length;i++){
			if(list[i][value_name] == value){
				return list[i][text_name];
			}
		}
	}

	return "";
}